import { render, staticRenderFns } from "./EvidenceReportTable.vue?vue&type=template&id=dd6f9b5a&"
import script from "./EvidenceReportTable.vue?vue&type=script&lang=js&"
export * from "./EvidenceReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports